import Vue from 'vue'
import Router from 'vue-router'
// Views - Auth
import Login from '@/views/auth/Login'
import Register from '@/views/auth/Register'
import Profile from '@/views/auth/Profile'
// ****************************************************
// Module Admin
// Views - Users
import AdminUsers from '@/views/admin/users/list'

import AdminUsersDel from '@/components/modules/admin/users_del/list'
// Views - Users create
import AdminUsersCreate from '@/views/admin/users/create'
// Views - Users edit
import AdminUsersEdit from '@/views/admin/users/edit'
// Views - Users profile
import AdminUsersProfile from '@/components/modules/admin/users/profile'
// ====================================================
// Views - Schools
import AdminSchools from '@/views/admin/schools/list'
// Views - Schools create
import AdminSchoolsCreate from '@/views/admin/schools/create'
// Views - Schools edit
import AdminSchoolsEdit from '@/views/admin/schools/edit'
// Views - School profile
// import AdminSchool from '@/views/admin/schools/profile'
// ====================================================
// Views - turns
import AdminTurns from '@/views/admin/turns/list'
// Views - turns create
import AdminTurnsCreate from '@/views/admin/turns/create'
// Views - turns edit
import AdminTurnsEdit from '@/views/admin/turns/edit'
// ====================================================
// Views - carnets
import AdminCarnets from '@/views/admin/carnets/list'
import AdminCarnetsNoActions from '@/views/admin/carnets/list_no_actions'
// Views - turns create
import AdminCarnetsCreate from '@/views/admin/carnets/create'
// Views - turns edit
import AdminCarnetsEdit from '@/views/admin/carnets/edit'
import AdminCarnetsRecarga from '@/views/admin/carnets/recarga'
import AdminCarnetsDescarga from '@/views/admin/carnets/descarga'
import AdminCarnetsValidate from '@/views/admin/carnets/validate'

import AdminCarnetsValidateDisctount from '@/views/admin/carnets/validate_discount'
import AdminCarnetsReports from '@/views/admin/carnets/reports'

// *****************************************************
// Module Inventory
// Views - Products
import InventoryProducts from '@/views/inventory/products/list'
// Views - Products create
import InventoryProductsCreate from '@/views/inventory/products/create'
// Views - Products edit
import InventoryProductsEdit from '@/views/inventory/products/edit'
// ====================================================
// Views - products - Categories
import InventoryProductsCategories from '@/views/inventory/products/categories/list'
// Views - products - Categories create
import InventoryProductsCategoriesCreate from '@/views/inventory/products/categories/create'
// Views - products - Categories edit
import InventoryProductsCategoriesEdit from '@/views/inventory/products/categories/edit'
// ====================================================
// Views - products - SubCategories
import InventoryProductsSubCategories from '@/views/inventory/products/subcategories/list'
// Views - products - SubCategories create
import InventoryProductsSubCategoriesCreate from '@/views/inventory/products/subcategories/create'
// Views - products - SubCategories edit
import InventoryProductsSubCategoriesEdit from '@/views/inventory/products/subcategories/edit'
// ====================================================
// Views - Providers
import InventoryProviders from '@/views/inventory/providers/list'
// Views - Providers create
import InventoryProvidersCreate from '@/views/inventory/providers/create'
// Views - Providers edit
import InventoryProvidersEdit from '@/views/inventory/providers/edit'
// ====================================================
// Views - Reports
import InventoryReports from '@/views/inventory/reports/list'
// *****************************************
// Module cafeteria
// Views - requests
import CafeteriaRequests from '@/views/cafeteria/requests/list'
// Views - requests create
import CafeteriaRequestsValidate from '@/views/cafeteria/requests/validate'
// Views - requests create
import CafeteriaRequestsCreate from '@/views/cafeteria/requests/create'
// Views - requests edit
import CafeteriaRequestsEdit from '@/views/cafeteria/requests/edit'
// ====================================================
// Views - enlistment
import CafeteriaEnlistment from '@/views/cafeteria/enlistment/list'
// Views - enlistment create
import CafeteriaEnlistmentCreate from '@/views/cafeteria/enlistment/create'
// Views - enlistment edit
import CafeteriaEnlistmentEdit from '@/views/cafeteria/enlistment/edit'
// ====================================================
// Views - deliveries
import CafeteriaDeliveries from '@/views/cafeteria/deliveries/list'
// Views - deliveries create
import CafeteriaDeliveriesCreate from '@/views/cafeteria/deliveries/create'
// Views - deliveries edit
import CafeteriaDeliveriesEdit from '@/views/cafeteria/deliveries/edit'
// ====================================================
// Views - reports
import CafeteriaReports from '@/views/cafeteria/reports/list'
// Views - reversion
import Cafeteriareversion from '@/components/modules/cafeteria/reversion/list'
// *****************************************
/*********************************PAPELERIA************************************ */
//---------------------------Modulo Categorias--------------------
// Views - Products
import PapeleriaProducts from '@/views/papeleria/products/list'
// Views - Products create
import PapeleriaProductsCreate from '@/views/papeleria/products/create'
// Views - Products edit
import PapeleriaProductsEdit from '@/views/papeleria/products/edit'
// ====================================================
// Views - products - Categories
import PapeleriaProductsCategories from '@/views/papeleria/products/categories/list'
// Views - products - Categories create
import PapeleriaProductsCategoriesCreate from '@/views/papeleria/products/categories/create'
// Views - products - Categories edit
import PapeleriaProductsCategoriesEdit from '@/views/papeleria/products/categories/edit'
// ====================================================
// Views - products - SubCategories
import PapeleriaProductsSubCategories from '@/views/papeleria/products/subcategories/list'
// Views - products - SubCategories create
import PapeleriaProductsSubCategoriesCreate from '@/views/papeleria/products/subcategories/create'
// Views - products - SubCategories edit
import PapeleriaProductsSubCategoriesEdit from '@/views/papeleria/products/subcategories/edit'

import PapeleriaRequests from '@/views/papeleria/requests/list'
// Views - requests create
import PapeleriaRequestsValidate from '@/views/papeleria/requests/validate'
// Views - requests create
import PapeleriaRequestsCreate from '@/views/papeleria/requests/create'
// Views - requests edit
import PapeleriaRequestsEdit from '@/views/papeleria/requests/edit'
// ====================================================
// Views - enlistment
import PapeleriaEnlistment from '@/views/papeleria/enlistment/list'
// Views - enlistment create
import PapeleriaEnlistmentCreate from '@/views/papeleria/enlistment/create'
// Views - enlistment edit
import PapeleriaEnlistmentEdit from '@/views/papeleria/enlistment/edit'
// ====================================================
// Views - deliveries
import PapeleriaDeliveries from '@/views/papeleria/requests/entrega'
// Views - deliveries create
import PapeleriaDeliveriesCreate from '@/views/papeleria/deliveries/create'
// Views - deliveries edit
import PapeleriaDeliveriesEdit from '@/views/papeleria/deliveries/edit'
// ====================================================
// Views - reports
import PapeleriaReports from '@/views/papeleria/reports/list'
// Views - reversion
import Papeleriareversion from '@/components/modules/papeleria/reversion/list'
// *****************************************
// Module restaurant
//---------------------------Modulo Categorias--------------------
// Views - Products
import RestauranyProducts from '@/views/restaurant/products/list'
// Views - Products create
import RestauranyProductsCreate from '@/views/restaurant/products/create'
// Views - Products edit
import RestauranyProductsEdit from '@/views/restaurant/products/edit'
// ====================================================
// Views - products - Categories
import RestauranyProductsCategories from '@/views/restaurant/products/categories/list'
// Views - products - Categories create
import RestauranyProductsCategoriesCreate from '@/views/restaurant/products/categories/create'
// Views - products - Categories edit
import RestauranyProductsCategoriesEdit from '@/views/restaurant/products/categories/edit'
// ====================================================
// Views - products - SubCategories
import RestauranyProductsSubCategories from '@/views/restaurant/products/subcategories/list'
// Views - products - SubCategories create
import RestauranyProductsSubCategoriesCreate from '@/views/restaurant/products/subcategories/create'
// Views - products - SubCategories edit
import RestauranyProductsSubCategoriesEdit from '@/views/restaurant/products/subcategories/edit'

// Views - categories
import Restaurantcategories from '@/views/restaurant/categories/list'
// Views - categories create
import RestaurantcategoriesCreate from '@/views/restaurant/categories/create'
// Views - categories edit
import RestaurantcategoriesEdit from '@/views/restaurant/categories/edit'

// Views - requests
import RestaurantRequests from '@/views/restaurant/requests/list'
// Views - requests create
import RestaurantRequestsCreate from '@/views/restaurant/requests/create'
// Views - requests edit
import RestaurantRequestsEdit from '@/views/restaurant/requests/edit'
// ====================================================
// Views - enlistment
import RestaurantEnlistment from '@/views/restaurant/enlistment/list'
// Views - enlistment create
import RestaurantEnlistmentCreate from '@/views/restaurant/enlistment/create'
// Views - enlistment edit
import RestaurantEnlistmentEdit from '@/views/restaurant/enlistment/edit'
// ====================================================
// Views - deliveries
import RestaurantDeliveries from '@/views/restaurant/deliveries/list'
// Views - deliveries create
import RestaurantDeliveriesCreate from '@/views/restaurant/deliveries/create'
// Views - deliveries edit
import RestaurantDeliveriesEdit from '@/views/restaurant/deliveries/edit'
// ====================================================
// Views - reports
import RestaurantReports from '@/views/restaurant/reports/list'
// Views - reversion
import Restaurantreversion from '@/components/modules/restaurant/reversion/list'
// *****************************************
// Module retaineds
// Views - retaineds
// import Retaineds from '@/views/retaineds/reports/list'
// *****************************************
// Module routesSchools
// Views - drivers
import SchoolsRoutesDrivers from '@/views/schoolroutes/drivers/list'
// Views - drivers create
import SchoolsRoutesDriversCreate from '@/views/schoolroutes/drivers/create'
// Views - drivers edit
import SchoolsRoutesDriversEdit from '@/views/schoolroutes/drivers/edit'
// ====================================================
// Views - messenger
import SchoolsRoutesMessenger from '@/views/schoolroutes/messenger/list'
// Views - messenger create
import SchoolsRoutesMessengerCreate from '@/views/schoolroutes/messenger/create'
// Views - messenger edit
import SchoolsRoutesMessengerEdit from '@/views/schoolroutes/messenger/edit'
// ====================================================
// Views - monitors
import SchoolsRoutesMonitors from '@/views/schoolroutes/monitors/list'
// Views - monitors create
import SchoolsRoutesMonitorsCreate from '@/views/schoolroutes/monitors/create'
// Views - monitors
import SchoolsRoutesMonitorsEdit from '@/views/schoolroutes/monitors/edit'
// ====================================================
// Views - news
import SchoolsRoutesNews from '@/views/schoolroutes/news/list'
// Views - news create
import SchoolsRoutesNewsCreate from '@/views/schoolroutes/news/create'
// Views - news
import SchoolsRoutesNewsEdit from '@/views/schoolroutes/news/edit'
// ====================================================
// Views - reports
import SchoolsRoutesReports from '@/views/schoolroutes/reports/list'
// ====================================================
// Views - vehicles
import SchoolsRoutesVehicles from '@/views/schoolroutes/vehicles/list'
// Views - vehicles
import SchoolsRoutesVehiclesCreate from '@/views/schoolroutes/vehicles/create'
// Views - vehicles
import SchoolsRoutesVehiclesEdit from '@/views/schoolroutes/vehicles/edit'
// ====================================================
// Views - routes
import SchoolsRoutesRoutes from '@/views/schoolroutes/routes/list'
import SchoolsRoutesRoutesCreate from '@/views/schoolroutes/routes/create'
import SchoolsRoutesRoutesEdit from '@/views/schoolroutes/routes/edit'

// Views - routes
import SchoolsRoutesAsignate from '@/views/schoolroutes/asignate/list'
import SchoolsRoutesAsignateCreate from '@/views/schoolroutes/asignate/create'
import SchoolsRoutesAsignateEdit from '@/views/schoolroutes/asignate/edit'
// ====================================================
import studentsList from '@/components/modules/academic/students/list'
import studentsCreate from '@/components/modules/academic/students/create'
import studentsEdit from '@/components/modules/academic/students/edit'

import attendantList from '@/components/modules/academic/attendant/list'
import attendantCreate from '@/components/modules/academic/attendant/create'
import attendantEdit from '@/components/modules/academic/attendant/edit'

import coursesList from '@/components/modules/academic/courses/list'
import coursesCreate from '@/components/modules/academic/courses/create'
import coursesEdit from '@/components/modules/academic/courses/edit'

import blockList from '@/components/modules/academic/block_products/list'
import blockProducts from '@/components/modules/academic/block_products/products'

// Views - Dashboard
import Dashboard from '@/views/dashboard/Dashboard'
// Views - routes
import externalEnlisment from '@/views/external/enlistment/'
import turnsExternal from '@/views/external/turns/'
import turnsExternalPapeleria from '@/views/external/turns/papeleria'
import turnsExternalRestaurante from '@/views/external/turns/restaurante'
import entregaExternal from '@/views/external/entrega/'
import validateExternal from '@/views/external/entrega/validate'
import validateRequest from '@/views/external/pedido'

// Containers
import DefaultContainer from '@/containers/DefaultContainer'

// Base - Components
import Colors from '@/views/base/theme/Colors'
import Typography from '@/views/base/theme/Typography'
import Charts from '@/views/base/charts/Charts'
import Widgets from '@/views/base/widgets/Widgets'
import Cards from '@/views/base/Cards'
import Forms from '@/views/base/Forms'
import Switches from '@/views/base/Switches'
import Tables from '@/views/base/Tables'
import Tabs from '@/views/base/Tabs'
import Breadcrumbs from '@/views/base/Breadcrumbs'
import Carousels from '@/views/base/Carousels'
import Collapses from '@/views/base/Collapses'
import Jumbotrons from '@/views/base/Jumbotrons'
import ListGroups from '@/views/base/ListGroups'
import Navs from '@/views/base/Navs'
import Navbars from '@/views/base/Navbars'
import Paginations from '@/views/base/Paginations'
import Popovers from '@/views/base/Popovers'
import ProgressBars from '@/views/base/ProgressBars'
import Tooltips from '@/views/base/Tooltips'

// Views - Buttons
import StandardButtons from '@/views/base/buttons/StandardButtons'
import ButtonGroups from '@/views/base/buttons/ButtonGroups'
import Dropdowns from '@/views/base/buttons/Dropdowns'
import BrandButtons from '@/views/base/buttons/BrandButtons'

// Views - Icons
import Flags from '@/views/base/icons/Flags'
import FontAwesome from '@/views/base/icons/FontAwesome'
import SimpleLineIcons from '@/views/base/icons/SimpleLineIcons'
import CoreUIIcons from '@/views/base/icons/CoreUIIcons'

// Views - Notifications
import Alerts from '@/views/base/notifications/Alerts'
import Badges from '@/views/base/notifications/Badges'
import Modals from '@/views/base/notifications/Modals'

// Views - Pages
import Page404 from '@/views/base/pages/Page404'
import Page500 from '@/views/base/pages/Page500'

import store from '../store' // your vuex store

// control de acceso
import qracces from '@/components/modules/controlacceso/qracces'
import permissacces from '@/components/modules/controlacceso/permiss'
import reports from '@/components/modules/controlacceso/reports'
import turns from '@/components/modules/controlacceso/turns'
import turnsedit from '@/components/modules/controlacceso/turnsedit'

import createRoles from '@/components/modules/admin/roles/create'
import editRoles from '@/components/modules/admin/roles/edit'
import listRoles from '@/components/modules/admin/roles/list'

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAutenticated) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAutenticated) {
    next()
    return
  }
  next('/auth/login')
}

const credentialSet = (to, from, next) => {
  if (store.getters.cafeteriaRequests.credential) {
    next()
    return
  }
  next('/cafeteria/requests/create')
}

Vue.use(Router)

const router = new Router({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/turns',
      name: 'Turns',
      component: turnsExternal
    },

    {
      path: '/papeleria/turns',
      name: 'Turns',
      component: turnsExternalPapeleria
    },
    {
      path: '/restaurante/turns',
      name: 'externalTurnsRestaurant',
      component: turnsExternalRestaurante
    },
    {
      path: '/auth',
      redirect: '/auth/login',
      name: 'Auth',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login,
          meta: {
            map_state: 'map_state_dashboard'
          },
          beforeEnter: ifNotAuthenticated
        },
        {
          path: 'register',
          name: 'Register',
          component: Register,
          meta: {
            map_state: 'map_state_dashboard'
          },
          beforeEnter: ifNotAuthenticated
        },
        {
          path: 'profile',
          name: 'Profile',
          component: Profile,
          meta: {
            map_state: 'map_state_dashboard'
          },
          beforeEnter: ifAuthenticated
        }
      ]
    },
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Inicio',
      beforeEnter: ifAuthenticated,
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          meta: {
            map_state: 'map_state_dashboard'
          },
          components: [
            Dashboard
          ]
        },
        {
          path: 'controlacceso',
          redirect: '/controlacceso/permiss',
          name: 'Controlacceso',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'qracces',
              name: 'qracces',
              component: qracces
            },
            {
              path: 'permiss',
              name: 'permiss',
              component: permissacces
            },
            {
              path: 'reports',
              name: 'reports',
              component: reports
            },
            {
              path: 'turns',
              name: 'turns',
              component: turns
            },
            {
              path: 'edit/:id',
              name: 'Editar',
              component: turnsedit
            }
          ]
        },
        {
          path: 'admin',
          redirect: '/admin/users',
          name: 'Administración',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'roles',
              redirect: '/admin/roles/list',
              name: 'roles',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Listar',
                  component: listRoles,
                  meta: {
                    map_state: 'map_state_rols'
                  }
                },
                {
                  path: 'create',
                  name: 'Crear',
                  component: createRoles,
                  meta: {
                    map_state: 'map_state_rols'
                  }
                },
                {
                  path: 'edit/:id',
                  name: 'Editar',
                  component: editRoles,
                  meta: {
                    map_state: 'map_state_rols'
                  }
                }
              ]
            },
            {
              path: 'users',
              redirect: '/admin/users/list',
              name: 'users',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Listar',
                  component: AdminUsers,
                  meta: {
                    map_state: 'map_state_users'
                  }
                },
                {
                  path: 'create',
                  name: 'Crear',
                  component: AdminUsersCreate,
                  meta: {
                    map_state: 'map_state_users'
                  }
                },
                {
                  path: 'edit/:id',
                  name: 'Editar',
                  component: AdminUsersEdit,
                  meta: {
                    map_state: 'map_state_users'
                  }
                },
                {
                  path: 'dels',
                  name: 'Inactivados',
                  component: AdminUsersDel,
                  meta: {
                    map_state: 'map_state_users'
                  }
                },
                {
                  path: 'profile',
                  name: 'Proflie',
                  component: AdminUsersProfile,
                  meta: {
                    map_state: 'map_state_users'
                  }
                }
              ]
            },
            /* {
              path: 'schools',
              redirect: '/admin/schools/list',
              name: 'Colegios',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: AdminSchools
                },
                {
                  path: 'create',
                  name: 'Crear',
                  component: AdminSchoolsCreate
                },
                {
                  path: 'edit/:id',
                  name: 'Editar',
                  component: AdminSchoolsEdit
                }
              ]
            } */,
            {
              path: 'turns',
              redirect: '/admin/turns/list',
              name: 'Turnos',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: AdminTurns
                },
                {
                  path: 'create',
                  name: 'Crear',
                  component: AdminTurnsCreate
                },
                {
                  path: 'edit/:id',
                  name: 'Editar',
                  component: turnsedit
                }
              ]
            },
            {
              path: 'validatecarnet',
              name: 'Validar',
              component: AdminCarnetsValidate,
            },
            {
              path: 'validatecarnet/desc',
              name: 'Validar',
              component: AdminCarnetsValidateDisctount,
            },
            {
              path: 'carnets',
              redirect: '/admin/carnets/list',
              name: 'Carnets',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: AdminCarnets
                },
                {
                  path: 'list_no_actions',
                  name: 'Lista sin acciones',
                  component: AdminCarnetsNoActions
                },
                {
                  path: 'create',
                  name: 'Crear',
                  component: AdminCarnetsCreate
                },                
                {
                  path: 'reports',
                  name: 'Reportes',
                  component: AdminCarnetsReports
                },
                {
                  path: 'edit/:id',
                  name: 'Editar',
                  component: AdminCarnetsEdit
                },
                {
                  path: 'recargar/:id',
                  name: 'Recargar',
                  component: AdminCarnetsRecarga
                },
                {
                  path: 'descarga/:id',
                  name: 'descarga',
                  component: AdminCarnetsDescarga
                }
                
              ]
            }
          ]
        },
        {
          path: 'academic',
          redirect: '/academic/students',
          name: 'Academico',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'students',
              redirect: '/academic/students/list',
              name: 'estudiantes',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Listar',
                  component: studentsList,
                  meta: {
                    map_state: 'map_state_rols'
                  }
                },
                {
                  path: 'create',
                  name: 'Crear',
                  component: studentsCreate,
                  meta: {
                    map_state: 'map_state_rols'
                  }
                },
                {
                  path: 'edit/:id',
                  name: 'Editar',
                  component: studentsEdit,
                  meta: {
                    map_state: 'map_state_rols'
                  }
                }
              ]
            },
            {
              path: 'attendant',
              redirect: '/academic/attendant/list',
              name: 'Acudientes',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Listar',
                  component: attendantList,
                  meta: {
                    map_state: 'map_state_users'
                  }
                },
                {
                  path: 'create',
                  name: 'Crear',
                  component: AdminUsersCreate,
                  meta: {
                    map_state: 'map_state_users'
                  }
                },
                {
                  path: 'edit/:id',
                  name: 'Editar',
                  component: attendantEdit,
                  meta: {
                    map_state: 'map_state_users'
                  }
                },
                {
                  path: 'profile',
                  name: 'Proflie',
                  component: AdminUsersProfile,
                  meta: {
                    map_state: 'map_state_users'
                  }
                }
              ]
            },
            {
              path: 'locks',
              redirect: '/academic/locks/list',
              name: 'Bloqueos',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Listar',
                  component: blockList,
                  meta: {
                    map_state: 'map_state_users'
                  }
                },
                {
                  path: 'create/:credential',
                  name: 'Crear',
                  component: blockProducts,
                  meta: {
                    map_state: 'map_state_users'
                  }
                },
                {
                  path: 'edit/:credential',
                  name: 'Editar',
                  component: coursesEdit,
                  meta: {
                    map_state: 'map_state_users'
                  }
                },
                {
                  path: 'profile',
                  name: 'Proflie',
                  component: AdminUsersProfile,
                  meta: {
                    map_state: 'map_state_users'
                  }
                }
              ]
            },
            {
              path: 'courses',
              redirect: '/academic/courses/list',
              name: 'Cursos',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Listar',
                  component: coursesList,
                  meta: {
                    map_state: 'map_state_users'
                  }
                },
                {
                  path: 'create',
                  name: 'Crear',
                  component: coursesCreate,
                  meta: {
                    map_state: 'map_state_users'
                  }
                },
                {
                  path: 'edit/:id',
                  name: 'Editar',
                  component: coursesEdit,
                  meta: {
                    map_state: 'map_state_users'
                  }
                },
                {
                  path: 'profile',
                  name: 'Proflie',
                  component: AdminUsersProfile,
                  meta: {
                    map_state: 'map_state_users'
                  }
                }
              ]
            }
          ]
        },
        {
          path: 'inventory',
          redirect: '/inventory/products',
          name: 'Inventario',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'products',
              redirect: '/inventory/products/list',
              name: 'Productos',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: InventoryProducts
                },
                {
                  path: 'create',
                  name: 'Crear',
                  component: InventoryProductsCreate
                },
                {
                  path: 'edit/:id',
                  name: 'Editar',
                  component: InventoryProductsEdit
                },
                {
                  path: 'categories',
                  redirect: '/inventory/products/categories/list',
                  name: 'Categorias',
                  component: {
                    render(c) {
                      return c('router-view')
                    }
                  },
                  children: [
                    {
                      path: 'list',
                      name: 'Lista',
                      component: InventoryProductsCategories
                    },
                    {
                      path: 'create',
                      name: 'Crear',
                      component: InventoryProductsCategoriesCreate
                    },
                    {
                      path: 'edit/:id',
                      name: 'Editar',
                      component: InventoryProductsCategoriesEdit
                    }
                  ]
                },
                {
                  path: 'subcategories',
                  redirect: '/inventory/products/subcategories/list',
                  name: 'Sub categorias',
                  component: {
                    render(c) {
                      return c('router-view')
                    }
                  },
                  children: [
                    {
                      path: 'list',
                      name: 'Lista',
                      component: InventoryProductsSubCategories
                    },
                    {
                      path: 'create',
                      name: 'Crear',
                      component: InventoryProductsSubCategoriesCreate
                    },
                    {
                      path: 'edit/:id',
                      name: 'Editar',
                      component: InventoryProductsSubCategoriesEdit
                    }
                  ]
                }
              ]
            },
            {
              path: 'providers',
              redirect: '/inventory/providers/list',
              name: 'Proveedores',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: InventoryProviders
                },
                {
                  path: 'create',
                  name: 'Crear',
                  component: InventoryProvidersCreate
                },
                {
                  path: 'edit/:id',
                  name: 'Editar',
                  component: InventoryProvidersEdit
                }
              ]
            },
            {
              path: 'reports',
              redirect: '/inventory/reports/list',
              name: 'Reportes',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: InventoryReports
                }
              ]
            }
          ]
        },
        {
          path: 'cafeteria',
          redirect: '/cafeteria/requests/list',
          name: 'Cafeteria',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'requests',
              redirect: '/cafeteria/requests/list',
              name: 'Pedidos',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: CafeteriaRequests
                },
                {
                  path: 'create',
                  name: 'Validar',
                  component: validateRequest
                },
                {
                  path: 'recreate',
                  name: 'recreate',
                  beforeEnter: credentialSet,
                  component: CafeteriaRequestsCreate
                },
                {
                  path: 'edit/:id',
                  name: 'Editar',
                  component: CafeteriaRequestsEdit
                }
              ]
            },
            {
              path: 'enlistment',
              redirect: '/cafeteria/enlistment/list',
              name: 'Enlistamiento',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: CafeteriaEnlistment
                },
                {
                  path: 'create',
                  name: 'Crear',
                  component: CafeteriaEnlistmentCreate
                },
                {
                  path: 'edit/:id',
                  name: 'Editar',
                  component: CafeteriaEnlistmentEdit
                }
              ]
            },
            {
              path: 'deliveries',
              redirect: '/cafeteria/deliveries/list',
              name: 'Entregas',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: CafeteriaDeliveries
                },
                {
                  path: 'create',
                  name: 'Crear',
                  component: CafeteriaDeliveriesCreate
                },
                {
                  path: 'edit/:id',
                  name: 'Editar',
                  component: CafeteriaDeliveriesEdit
                }
              ]
            },
            {
              path: 'reports',
              redirect: '/cafeteria/reports/list',
              name: 'Reportes',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: CafeteriaReports
                }
              ]
            },
            {
              path: 'Reversion',
              redirect: '/cafeteria/reversion/list',
              name: 'reversion',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: Cafeteriareversion
                }
              ]
            }
          ]
        },
        {
        path: 'papeleria',
        redirect: '/papeleria/requests/list',
        name: 'Papeleria',
        component: {
          render(c) {
            return c('router-view')
          }
        },
        children: [
          {
            path: 'products',
            redirect: '/papeleria/products/list',
            name: 'Productos',
            component: {
              render(c) {
                return c('router-view')
              }
            },
            children: [
              {
                path: 'list',
                name: 'Lista',
                component: PapeleriaProducts
              },
              {
                path: 'create',
                name: 'Crear',
                component: PapeleriaProductsCreate
              },
              {
                path: 'edit/:id',
                name: 'Editar',
                component: PapeleriaProductsEdit
              },
              {
                path: 'categories',
                redirect: '/papeleria/products/categories/list',
                name: 'Categorias',
                component: {
                  render(c) {
                    return c('router-view')
                  }
                },
                children: [
                  {
                    path: 'list',
                    name: 'Lista',
                    component: PapeleriaProductsCategories
                  },
                  {
                    path: 'create',
                    name: 'Crear',
                    component: PapeleriaProductsCategoriesCreate
                  },
                  {
                    path: 'edit/:id',
                    name: 'Editar',
                    component: PapeleriaProductsCategoriesEdit
                  }
                ]
              },
              {
                path: 'subcategories',
                redirect: '/papeleria/products/subcategories/list',
                name: 'Sub categorias',
                component: {
                  render(c) {
                    return c('router-view')
                  }
                },
                children: [
                  {
                    path: 'list',
                    name: 'Lista',
                    component:PapeleriaProductsSubCategories
                  },
                  {
                    path: 'create',
                    name: 'Crear',
                    component: PapeleriaProductsSubCategoriesCreate
                  },
                  {
                    path: 'edit/:id',
                    name: 'Editar',
                    component: PapeleriaProductsSubCategoriesEdit
                  }
                ]
              }
            ]
          },
          {
            path: 'requests',
            redirect: '/papeleria/requests/list',
            name: 'Pedidos',
            component: {
              render(c) {
                return c('router-view')
              }
            },
            children: [
              {
                path: 'list',
                name: 'Lista',
                component: PapeleriaRequests
              },
              {
                path: 'create',
                name: 'Validar',
                component: PapeleriaRequestsValidate
              },
              {
                path: 'recreate',
                name: 'recreate',
                component: PapeleriaRequestsCreate
              },
              {
                path: 'edit/:id',
                name: 'Editar',
                component: PapeleriaRequestsEdit
              }
            ]
          },
          {
            path: 'enlistment',
            redirect: '/papeleria/enlistment/list',
            name: 'Enlistamiento',
            component: {
              render(c) {
                return c('router-view')
              }
            },
            children: [
              {
                path: 'list',
                name: 'Lista',
                component: PapeleriaEnlistment
              },
              {
                path: 'create',
                name: 'Crear',
                component: PapeleriaEnlistmentCreate
              },
              {
                path: 'edit/:id',
                name: 'Editar',
                component: PapeleriaEnlistmentEdit
              }
            ]
          },
          {
            path: 'deliveries',
            redirect: '/papeleria/deliveries/list',
            name: 'Entregas',
            component: {
              render(c) {
                return c('router-view')
              }
            },
            children: [
              {
                path: 'list',
                name: 'Lista',
                component: PapeleriaDeliveries
              },
              {
                path: 'create',
                name: 'Crear',
                component: PapeleriaDeliveriesCreate
              },
              {
                path: 'edit/:id',
                name: 'Editar',
                component: PapeleriaDeliveriesEdit
              }
            ]
          },
          {
            path: 'reports',
            redirect: '/papeleria/reports/list',
            name: 'Reportes',
            component: {
              render(c) {
                return c('router-view')
              }
            },
            children: [
              {
                path: 'list',
                name: 'Lista',
                component: PapeleriaReports
              }
            ]
          },
          {
            path: 'Reversion',
            redirect: '/papeleria/reversion/list',
            name: 'reversion',
            component: {
              render(c) {
                return c('router-view')
              }
            },
            children: [
              {
                path: 'list',
                name: 'Lista',
                component: Papeleriareversion
              }
            ]
          }
        ]
      },
        {
          path: 'external',
          redirect: '/external/list',
          name: 'external',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'request',
              name: 'Pedidos',
              component: validateRequest
            },
            {
              path: 'list',
              name: 'externalList',
              component: externalEnlisment
            },
            {
              path: 'turns',
              name: 'externalTurns',
              component: turnsExternal
            },
            {
              path: 'turns-restaurant',
              name: 'externalTurnsRestaurant',
              component: turnsExternalRestaurante
            },
            {
              path: 'entrega',
              name: 'externalList',
              component: validateExternal
            },
            {
              path: 'dispatch',
              name: 'externalDispatch',
              component: entregaExternal
            }
          ]
        },

        {
          path: 'restaurant',
          redirect: '/restaurant/requests/list',
          name: 'Restaurante',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'products',
              redirect: '/restaurant/products/list',
              name: 'Productos',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: RestauranyProducts
                },
                {
                  path: 'create',
                  name: 'Crear',
                  component: RestauranyProductsCreate
                },
                {
                  path: 'edit/:id',
                  name: 'Editar',
                  component: RestauranyProductsEdit
                },
                {
                  path: 'categories',
                  redirect: '/restaurant/products/categories/list',
                  name: 'Categorias',
                  component: {
                    render(c) {
                      return c('router-view')
                    }
                  },
                  children: [
                    {
                      path: 'list',
                      name: 'Lista',
                      component: RestauranyProductsCategories
                    },
                    {
                      path: 'create',
                      name: 'Crear',
                      component: RestauranyProductsCategoriesCreate
                    },
                    {
                      path: 'edit/:id',
                      name: 'Editar',
                      component: RestauranyProductsCategoriesEdit
                    }
                  ]
                },
                {
                  path: 'subcategories',
                  redirect: '/restaurant/products/subcategories/list',
                  name: 'Sub categorias',
                  component: {
                    render(c) {
                      return c('router-view')
                    }
                  },
                  children: [
                    {
                      path: 'list',
                      name: 'Lista',
                      component: RestauranyProductsSubCategories
                    },
                    {
                      path: 'create',
                      name: 'Crear',
                      component: RestauranyProductsSubCategoriesCreate
                    },
                    {
                      path: 'edit/:id',
                      name: 'Editar',
                      component: RestauranyProductsSubCategoriesEdit
                    }
                  ]
                }
              ]
            },
            {
              path: 'categories',
              redirect: '/restaurant/categories/list',
              name: 'Categorias',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: Restaurantcategories
                },
                {
                  path: 'create',
                  name: 'Crear',
                  component: RestaurantcategoriesCreate
                },
                {
                  path: 'edit/:id',
                  name: 'Editar',
                  component: RestaurantcategoriesEdit
                }
              ]
            },
            {
              path: 'Reversion',
              redirect: '/restaurant/reversion/list',
              name: 'reversion',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: Restaurantreversion
                }
              ]
            },
            {
              path: 'requests',
              redirect: '/restaurant/requests/list',
              name: 'Pedidos',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: RestaurantRequests
                },
                {
                  path: 'create',
                  name: 'Crear',
                  component: RestaurantRequestsCreate
                },
                {
                  path: 'edit/:id',
                  name: 'Editar',
                  component: RestaurantRequestsEdit
                }
              ]
            },
            // {
            //   path: 'enlistment',
            //   redirect: '/restaurant/enlistment/list',
            //   name: 'Enlistamiento',
            //   component: {
            //     render(c) {
            //       return c('router-view')
            //     }
            //   },
            //   children: [
            //     {
            //       path: 'list',
            //       name: 'Lista',
            //       component: RestaurantEnlistment
            //     },
            //     {
            //       path: 'create',
            //       name: 'Crear',
            //       component: RestaurantEnlistmentCreate
            //     },
            //     {
            //       path: 'edit/:id',
            //       name: 'Editar',
            //       component: RestaurantEnlistmentEdit
            //     }
            //   ]
            // },
            {
              path: 'deliveries',
              redirect: '/restaurant/deliveries/list',
              name: 'Entregas',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: RestaurantDeliveries
                },
                {
                  path: 'create',
                  name: 'Crear',
                  component: RestaurantDeliveriesCreate
                },
                {
                  path: 'edit/:id',
                  name: 'Editar',
                  component: RestaurantDeliveriesEdit
                }
              ]
            },
            {
              path: 'reports',
              redirect: '/restaurant/reports/list',
              name: 'Reportes',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: RestaurantReports
                }
              ]
            },
            {
              path: 'external',
              redirect: '/restaurant/external/list',
              name: 'external',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: externalEnlisment
                },
                {
                  path: 'turns',
                  name: 'Turns',
                  component: turnsExternal
                }
              ]
            }
          ]
        },
        {
          path: 'schoolroutes',
          redirect: '/schoolroutes/drivers/list',
          name: 'Rutas escolares',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'drivers',
              redirect: '/schoolroutes/drivers/list',
              name: 'Conductores',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: SchoolsRoutesDrivers
                },
                {
                  path: 'create',
                  name: 'Crear',
                  component: SchoolsRoutesDriversCreate
                },
                {
                  path: 'edit/:id',
                  name: 'Editar',
                  component: SchoolsRoutesDriversEdit
                }
              ]
            },
            {
              path: 'messenger',
              redirect: '/schoolroutes/messenger/list',
              name: 'Mensajeria',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: SchoolsRoutesMessenger
                },
                {
                  path: 'create',
                  name: 'Crear',
                  component: SchoolsRoutesMessengerCreate
                },
                {
                  path: 'edit/:id',
                  name: 'Editar',
                  component: SchoolsRoutesMessengerEdit
                }
              ]
            },
            {
              path: 'monitors',
              redirect: '/schoolroutes/monitors/list',
              name: 'Monitores',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: SchoolsRoutesMonitors
                },
                {
                  path: 'create',
                  name: 'Crear',
                  component: SchoolsRoutesMonitorsCreate
                },
                {
                  path: 'edit/:id',
                  name: 'Editar',
                  component: SchoolsRoutesMonitorsEdit
                }
              ]
            },
            {
              path: 'news',
              redirect: '/schoolroutes/news/list',
              name: 'Novedades',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: SchoolsRoutesNews
                },
                {
                  path: 'create',
                  name: 'Crear',
                  component: SchoolsRoutesNewsCreate
                },
                {
                  path: 'edit/:id',
                  name: 'Editar',
                  component: SchoolsRoutesNewsEdit
                }
              ]
            },
            {
              path: 'reports',
              redirect: '/restaurant/reports/list',
              name: 'Reportes',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: SchoolsRoutesReports
                }
              ]
            },
            {
              path: 'vehicles',
              redirect: '/schoolroutes/vehicles/list',
              name: 'Vehiculos',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: SchoolsRoutesVehicles
                },
                {
                  path: 'create',
                  name: 'Crear',
                  component: SchoolsRoutesVehiclesCreate
                },
                {
                  path: 'edit/:id',
                  name: 'Editar',
                  component: SchoolsRoutesVehiclesEdit
                }
              ]
            },
            {
              path: 'routes',
              redirect: 'routes/list',
              name: 'Routes',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: SchoolsRoutesRoutes
                },
                {
                  path: 'create',
                  name: 'Crear',
                  component: SchoolsRoutesRoutesCreate
                },
                {
                  path: 'edit/:id',
                  name: 'Editar',
                  component: SchoolsRoutesRoutesEdit
                }
              ]
            },
            {
              path: 'asignate',
              redirect: 'asignate/list',
              name: 'asignate',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: SchoolsRoutesAsignate
                },
                {
                  path: 'create',
                  name: 'Crear',
                  component: SchoolsRoutesAsignateCreate
                },
                {
                  path: 'edit/:id',
                  name: 'Editar',
                  component: SchoolsRoutesAsignateEdit
                }
              ]
            },
            {
              path: 'reports',
              redirect: '/restaurant/reports/list',
              name: 'Reportes',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: RestaurantReports
                }
              ]
            },
            {
              path: 'vehicles',
              redirect: '/schoolroutes/vehicles/list',
              name: 'Vehiculos',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'Lista',
                  component: SchoolsRoutesRoutes
                },
                {
                  path: 'create',
                  name: 'Crear',
                  component: SchoolsRoutesRoutesCreate
                },
                {
                  path: 'edit/:id',
                  name: 'Editar',
                  component: SchoolsRoutesRoutesEdit
                }
              ]
            }
          ]
        },
        {
          path: 'base',
          redirect: '/base/cards',
          name: 'Base',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'theme',
              redirect: '/theme/colors',
              name: 'Theme',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'colors',
                  name: 'Colors',
                  component: Colors
                },
                {
                  path: 'typography',
                  name: 'Typography',
                  component: Typography
                }
              ]
            },
            {
              path: 'charts',
              name: 'Charts',
              component: Charts
            },
            {
              path: 'widgets',
              name: 'Widgets',
              component: Widgets
            },
            {
              path: 'cards',
              name: 'Cards',
              component: Cards
            },
            {
              path: 'forms',
              name: 'Forms',
              component: Forms
            },
            {
              path: 'switches',
              name: 'Switches',
              component: Switches
            },
            {
              path: 'tables',
              name: 'Tables',
              component: Tables
            },
            {
              path: 'tabs',
              name: 'Tabs',
              component: Tabs
            },
            {
              path: 'breadcrumbs',
              name: 'Breadcrumbs',
              component: Breadcrumbs
            },
            {
              path: 'carousels',
              name: 'Carousels',
              component: Carousels
            },
            {
              path: 'collapses',
              name: 'Collapses',
              component: Collapses
            },
            {
              path: 'jumbotrons',
              name: 'Jumbotrons',
              component: Jumbotrons
            },
            {
              path: 'list-groups',
              name: 'List Groups',
              component: ListGroups
            },
            {
              path: 'navs',
              name: 'Navs',
              component: Navs
            },
            {
              path: 'navbars',
              name: 'Navbars',
              component: Navbars
            },
            {
              path: 'paginations',
              name: 'Paginations',
              component: Paginations
            },
            {
              path: 'popovers',
              name: 'Popovers',
              component: Popovers
            },
            {
              path: 'progress-bars',
              name: 'Progress Bars',
              component: ProgressBars
            },
            {
              path: 'tooltips',
              name: 'Tooltips',
              component: Tooltips
            },
            {
              path: 'buttons',
              redirect: '/buttons/standard-buttons',
              name: 'Buttons',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'standard-buttons',
                  name: 'Standard Buttons',
                  component: StandardButtons
                },
                {
                  path: 'button-groups',
                  name: 'Button Groups',
                  component: ButtonGroups
                },
                {
                  path: 'dropdowns',
                  name: 'Dropdowns',
                  component: Dropdowns
                },
                {
                  path: 'brand-buttons',
                  name: 'Brand Buttons',
                  component: BrandButtons
                }
              ]
            },
            {
              path: 'icons',
              redirect: 'icons/font-awesome',
              name: 'Icons',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'coreui-icons',
                  name: 'CoreUI Icons',
                  component: CoreUIIcons
                },
                {
                  path: 'flags',
                  name: 'Flags',
                  component: Flags
                },
                {
                  path: 'font-awesome',
                  name: 'Font Awesome',
                  component: FontAwesome
                },
                {
                  path: 'simple-line-icons',
                  name: 'Simple Line Icons',
                  component: SimpleLineIcons
                }
              ]
            },
            {
              path: 'notifications',
              redirect: 'notifications/alerts',
              name: 'Notifications',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'alerts',
                  name: 'Alerts',
                  component: Alerts
                },
                {
                  path: 'badges',
                  name: 'Badges',
                  component: Badges
                },
                {
                  path: 'modals',
                  name: 'Modals',
                  component: Modals
                }
              ]
            },
            {
              path: 'pages',
              redirect: 'pages/404',
              name: 'Pages',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: '404',
                  name: 'Page404',
                  component: Page404
                },
                {
                  path: '500',
                  name: 'Page500',
                  component: Page500
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})

/* router.beforeEach((to,from,next) => {
  if (to.meta.map_state == 'map_state_dashboard'){
    next()
    return
  }else{
    let permission = JSON.parse(localStorage.getItem('permission'))
    permission.forEach(element => {
      if(String(to.meta.map_state) === String(element)){
        next()
        console.log("elemento ",to.meta.map_state+" == "+String(element))
        return
      }
    });
  }
  //next('/')
}) */
export default router



// WEBPACK FOOTER //
// ./src/router/index.js